import { useTranslation } from 'react-i18next'
import type { EstadoCamion } from '@/types'
import { COLOR_ESTADO } from '@/utils/camionesMuelle'

const ORDEN: EstadoCamion[] = ['programado', 'cargando', 'salido', 'enRiesgo', 'anulado']

/**
 * Qué significa cada color.
 *
 * Los colores salen de `COLOR_ESTADO`, el mismo objeto que usan las barras: si
 * vivieran en dos sitios, la leyenda acabaría diciendo que el ámbar es una cosa
 * mientras el carril lo pinta de otra.
 */
export function LeyendaEstados({ dark }: { dark: boolean }) {
  const { t } = useTranslation()
  const txtMuted = dark ? 'text-slate-400' : 'text-slate-500'
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
      {ORDEN.map((e) => (
        <span key={e} className={`inline-flex items-center gap-1.5 text-[10px] ${txtMuted}`}>
          <span className={`w-2.5 h-2.5 rounded-sm ${COLOR_ESTADO[e].barra} opacity-80`} />
          {t(`muelles.estado.${e}`)}
        </span>
      ))}
    </div>
  )
}
